import { FC, useRef } from 'react';
import { PopupActions } from 'reactjs-popup/dist/types';
import { useTheme } from 'styled-components/macro';

import UserCard from './components/UserCard/UserCard';
import useUserInfo from './hooks/useUserInfo';
import UserIconLoader from './UserIconLoader';
import {
  ButtonIconStyled,
  ButtonStyled,
  DropdownItemStyled,
  FlexContainerStyled,
  LinkStyled,
  getPopupContentStyle,
} from './UserInfo.styled';
import UserInfoLoader from './UserInfoLoader';
import Popup from 'components/Popup/Popup';
import { useResponsive } from 'contexts/ResponsiveContext';
import { useUserProfile } from 'contexts/UserProfileContext';
import { RoutePathsE } from 'declarations/enums/routes';

type UserInfoPropsT = {
  iconOnly?: boolean;
};

const UserInfo: FC<UserInfoPropsT> = ({ iconOnly }) => {
  const { userProfile, isLoadingUserProfile } = useUserProfile();
  const { handleSignOutClick } = useUserInfo();
  const { isMobile } = useResponsive();
  const menuPopupRef = useRef<PopupActions>(null);
  const theme = useTheme();

  return (
    <FlexContainerStyled iconOnly={iconOnly}>
      {isLoadingUserProfile && iconOnly ? (
        <UserIconLoader />
      ) : isLoadingUserProfile && !iconOnly ? (
        <UserInfoLoader />
      ) : (
        <Popup
          offsetY={4}
          arrow={false}
          ref={menuPopupRef}
          position={iconOnly ? 'bottom right' : 'top left'}
          contentStyle={getPopupContentStyle(theme, isMobile)}
          trigger={
            <ButtonIconStyled
              title="User profile settings"
              icon={<UserCard userProfile={userProfile} iconOnly={iconOnly} />}
            />
          }
        >
          <ul>
            <DropdownItemStyled>
              <LinkStyled to={RoutePathsE.PROFILE_PAGE}>Profile</LinkStyled>
            </DropdownItemStyled>

            <DropdownItemStyled>
              <ButtonStyled variant="text" onClick={handleSignOutClick}>
                Log out
              </ButtonStyled>
            </DropdownItemStyled>
          </ul>
        </Popup>
      )}
    </FlexContainerStyled>
  );
};

export default UserInfo;
